import { useEffect } from 'react';
import { useGet } from '../../lib/api/hooks';
import { Box, Typography } from '@mui/material';
import { useScreenSmallerThan } from '../../lib/hooks/breakpoint-hooks';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import EditIcon from '@mui/icons-material/Edit';

interface DeterminationDisagreementSectionProps {
    clinicalReviewId: string;
    hasAnsweredDisagreementQuestions: boolean;
    setHasAnsweredDisagreementQuestions: (answered: boolean) => void;
    handleOpenDisagreementQuestionsModal: () => void;
}

const DeterminationDisagreementSection = ({
    clinicalReviewId,
    setHasAnsweredDisagreementQuestions,
    hasAnsweredDisagreementQuestions,
    handleOpenDisagreementQuestionsModal
}: DeterminationDisagreementSectionProps) => {
    const isSmallerThanSmall = useScreenSmallerThan('sm');
    const { loading: isLoading, data } = useGet<{ determinationDisagreementExists: boolean }>(
        `determinationdisagreement/exists?clinicalReviewId=${clinicalReviewId}`
    );

    useEffect(() => {
        if (
            data?.determinationDisagreementExists !== null &&
            data?.determinationDisagreementExists !== undefined
        ) {
            setHasAnsweredDisagreementQuestions(data.determinationDisagreementExists);
        }
    }, [data?.determinationDisagreementExists, setHasAnsweredDisagreementQuestions]);

    if (isLoading) {
        return null;
    }

    return (
        <Box
            sx={{
                margin: !isSmallerThanSmall ? '0 1.25rem 0.875rem' : '0',
                padding: !isSmallerThanSmall ? '0 0.625rem 0.625rem' : '0.625rem 0.625rem'
            }}>
            <Box display="flex" alignItems="center" gap={1}>
                {!hasAnsweredDisagreementQuestions ? (
                    <ErrorOutlineIcon color="error" />
                ) : (
                    <EditIcon color="primary" />
                )}
                <Typography
                    sx={{ '&:hover': { cursor: 'pointer', textDecoration: 'underline' } }}
                    onClick={handleOpenDisagreementQuestionsModal}
                    color={!hasAnsweredDisagreementQuestions ? 'error' : 'primary'}>
                    {!hasAnsweredDisagreementQuestions
                        ? 'Please answer determination disagreement questions before submitting'
                        : 'View/edit determination disagreement questions'}
                </Typography>
            </Box>
        </Box>
    );
};

export default DeterminationDisagreementSection;
